import _ from 'lodash';
import {
  RECEIVE_PLANS,
  RECEIVE_DETAILS,
  RECEIVE_EFFECTIVE_DATE,
} from 'client/actions/plans/vision';

const initialState = {
  plans: [],
  stats: null,
  effectiveDate: null,
};

export default function visionPlans(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_EFFECTIVE_DATE:
      return { ...state, effectiveDate: action.effectiveDate };
    case RECEIVE_PLANS:
      return { ...state, plans: action.plans };
    case RECEIVE_DETAILS: {
      const plans = state.plans.slice(0);
      const index = _.findIndex(plans, { id: action.details.id });
      if (index < 0) {
        return state;
      }

      const extendedPlan = _.assign({}, plans[index], action.details);
      plans.splice(index, 1, extendedPlan);
      return { ...state, plans };
    }
    default:
      return state;
  }
}
